import { Header } from "../../models/Header";
import { categorie, departement, fournisseur, gamme, mode } from "./columns";

export const selectionHeaders: Header[] = [
  mode,
  {
    ...departement,
    field: "departement.dept_nom_aff",
  },
  {
    ...categorie,
    field: "categorie.cat_descr_aff",
  },
  fournisseur,
  {
    ...gamme,
    field: "gamme.gamme_descr",
  },
];
